<h1 mat-dialog-title class="dialog-header">
  {{ (data.action === 'disable' ? 'mfa.disable' : 'mfa.regenerate') | translate }}
</h1>
<mat-divider style="margin: 1rem !important;"></mat-divider>
<mat-dialog-content class="mat-typography">
  <!-- Step 1: ask for current code -->
  <div *ngIf="!done">
    <p class="mb-4 text-sm text-gray-600">{{ "mfa.codePrompt" | translate }}</p>

    <form [formGroup]="codeForm">
      <mat-form-field class="w-full">
        <mat-label>{{ "mfa.codeLabel" | translate }}</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          placeholder="000000"
          formControlName="code"
        />
      </mat-form-field>
    </form>

    <div *ngIf="error" class="text-sm mb-2" style="color: var(--primary_700)">
      {{ error | translate }}
    </div>

    <div class="float-right">
      <button mat-button mat-dialog-close>{{ "Cancel" | translate }}</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!codeForm.valid || submitting"
        (click)="submit()"
      >
        {{ (data.action === 'disable' ? 'mfa.disable' : 'mfa.regenerate') | translate }}
      </button>
    </div>
  </div>

  <!-- Step 2: show new backup codes (regenerate only) -->
  <div *ngIf="done">
    <p class="mb-3 text-sm text-gray-600">{{ "mfa.backupInstruction" | translate }}</p>
    <div class="grid grid-cols-2 gap-2 mb-4">
      <div
        *ngFor="let code of backupCodes"
        class="font-mono text-sm p-2 rounded bg-gray-100 text-center select-all"
      >
        {{ code }}
      </div>
    </div>
    <div class="float-right">
      <button mat-flat-button color="primary" (click)="close()">
        {{ "mfa.finish" | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
